/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const CHALLENGE_ISSUE_CATEGORIES = [
  'title',
  'definition',
  'usage',
  'examples',
  'video',
  'audio',
] as const;

export const challengeIssueCategorySchema = z.enum(CHALLENGE_ISSUE_CATEGORIES);

export type IChallengeIssueCategory = z.infer<typeof challengeIssueCategorySchema>;

export const CHALLENGE_ISSUE_CATEGORY_LABELS: Record<IChallengeIssueCategory, string> = {
  title: 'Title',
  definition: 'Definition',
  usage: 'Usage',
  examples: 'Examples',
  video: 'Video',
  audio: 'Audio',
};

export const challengeIssueDetailSchema = z.object({
  category: challengeIssueCategorySchema,
  reason: z.string(),
});

export type IChallengeIssueDetail = z.infer<typeof challengeIssueDetailSchema>;

export interface IChallengeIssueReasonOption {
  value: string;
  label: string;
}

export const CHALLENGE_ISSUE_CATEGORY_REASONS: Record<
  IChallengeIssueCategory,
  readonly IChallengeIssueReasonOption[]
> = {
  title: [
    { value: 'incorrect', label: 'Incorrect or misspelled' },
    { value: 'not_a_phrase', label: 'Not a real phrase' },
    { value: 'inappropriate', label: 'Inappropriate' },
    { value: 'other', label: 'Other' },
  ],
  definition: [
    { value: 'wrong_meaning', label: 'Wrong meaning' },
    { value: 'confusing', label: 'Confusing or unclear' },
    { value: 'translation_wrong', label: 'Translation is wrong' },
    { value: 'other', label: 'Other' },
  ],
  usage: [
    { value: 'incorrect', label: 'Incorrect' },
    { value: 'confusing', label: 'Confusing or unclear' },
    { value: 'translation_wrong', label: 'Translation is wrong' },
    { value: 'other', label: 'Other' },
  ],
  examples: [
    { value: 'unnatural', label: 'Unnatural or wrong' },
    { value: 'mismatch', label: 'Does not match the meaning' },
    { value: 'translation_wrong', label: 'Translation is wrong' },
    { value: 'other', label: 'Other' },
  ],
  video: [
    { value: 'timing_off', label: 'Timing is off' },
    { value: 'wrong_clip', label: 'Wrong or mismatched clip' },
    { value: 'poor_quality', label: 'Poor quality' },
    { value: 'inappropriate', label: 'Inappropriate' },
    { value: 'other', label: 'Other' },
  ],
  audio: [
    { value: 'wrong_pronunciation', label: 'Wrong pronunciation' },
    { value: 'no_sound', label: 'No sound or broken' },
    { value: 'wrong_audio', label: 'Wrong audio' },
    { value: 'other', label: 'Other' },
  ],
};
